import { Injectable } from '@angular/core';
import { SurveyService } from '../../../../../core/services/survey/survey.service';
import { M1SearchMultipleRecordsService } from './m1-search-multiple-records.service';
import { M1SearchSingleRecordService } from './m1-search-single-record.service';
import { FormAuthService } from '../../../../../core/services/auth/form-auth.service';
import { M1SearchRecordsService } from './m1-search-records.service';

@Injectable({
  providedIn: 'root'
})
export class M1SearchWidgetService {
  constructor(private surveyService: SurveyService,
              private m1SearchSingleRecordService: M1SearchSingleRecordService,
              private m1SearchMultipleRecordsService: M1SearchMultipleRecordsService,
              private m1SearchRecordsService: M1SearchRecordsService,
              private formAuthService: FormAuthService) {
  }

  async processM1Member(data: any, nrdsSearch: string, questionJson: any, model: any) {
    this.m1SearchRecordsService.questionJson = questionJson;
    const canHaveMultipleRecords = nrdsSearch !== 'LIC' && nrdsSearch !== 'NRDS';

    if (nrdsSearch === 'LIC') {
      data = this.filterLicenseDataResponse(data);
    }

    if (data?.length > 0) {
      if (canHaveMultipleRecords) {
        this.m1SearchMultipleRecordsService.processMultipleRecords(data, model);
      } else {
        await this.m1SearchSingleRecordService.processSingleRecord(data[0], nrdsSearch, model);
      }
    }

    if (!this.surveyService.surveyModel.getVariable('nrds_validated')) {
      /*$('#NRDSsearchError').html(survey.getVariable('nrds_request_error')).show();*/
    }
  }

  filterLicenseDataResponse(data: any) {
    if (data.length > 0) {
      data = data.filter((item: any) => {
        return (this.formAuthService.memberNrdsId &&
            item.member_nrds_id === this.formAuthService.memberNrdsId) ||
          (
            item.last_name.toLowerCase() === this.surveyService.surveyModel.getValue('LastName').toLowerCase() &&
            item.primary_re_license_number === this.surveyService.surveyModel.getValue('LicNumber')
          );
      });
    }

    return data;
  }
}
